import {Component, OnInit, ViewChild} from '@angular/core';
import { NavController } from '@ionic/angular';
import { WalletService } from '../../../angular-wallet-base/services/wallet.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { PhraseBuilderComponent } from '../../../components/phrase-builder/phrase-builder.component';
import { getSetupMnemonic } from '../../../angular-wallet-base/store/setup';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { SubscriptionListenerComponent } from 'src/app/angular-wallet-base/SubscriptionListenerComponent';

@Component({
  selector: 'confirm-recovery-phrase',
  templateUrl: 'confirm-recovery-phrase.page.html',
  styleUrls: ['confirm-recovery-phrase.page.scss']
})
export class ConfirmRecoveryPhrasePage extends SubscriptionListenerComponent implements OnInit {
  @ViewChild('phraseDesktop', { static: true }) phraseBuilderDesktop: PhraseBuilderComponent;
  @ViewChild('phraseMobile', { static: true }) phraseBuilderMobile: PhraseBuilderComponent;

  // should this be private
  public mnemonicPhrase: string;
  public completeButtonDisabled: boolean = true;
  public builtPhrase: string;
  public showLoader: boolean = false;
  public isDesktopMode;

  constructor(private nav: NavController,
              public store: Store<AppState>,
              private appMode: AppModeService,
              private walletService: WalletService) {
    super(store);
    this.builtPhrase = '';
  }
  ngOnInit() {
    this.subscriptions.add(this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode));

    this.store.select(getSetupMnemonic).subscribe(mnemonic => {
        this.mnemonicPhrase = mnemonic;
    });
  }

  phraseChange(phrase) {
    this.builtPhrase = phrase;
    this.completeButtonDisabled = !(phrase === this.mnemonicPhrase);
  }

  deleteWord() {
    if(this.isDesktopMode) {
      this.phraseBuilderDesktop.builtPhraseDeleteWord();
    } else {
      this.phraseBuilderMobile.builtPhraseDeleteWord();
    }
  }

  completeSetup() {
    this.showLoader = true;
    setTimeout(async () => {
      await this.walletService.completeSetup();
      this.showLoader = false;
      await this.nav.navigateRoot('/wallet/assets');
    }, 10)
  }
}
